import { setupClickTracking } from '../../shared/clicks';

// Bootstrap page specific clicks here if need be before passing off to main click file.

export const setupLdpClickTracking = function(pageStatus) {
  if (!window.rdcTrackingInitialized) {
    setupClickTracking(pageStatus);
  }
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/pages/ldp/ldp_clicks.js